import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import RetencionMoreActions from './RetencionMoreActions';
import RetencionDownloadActions from './RetencionDownloadActions';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import PopConfirm from '../../../../facturotopia/popconfirm/PopConfirm';

class SingleRetencionActions extends Component {

  state = {
    showConfirm: false
  }

  handleOnCancelRequest = () => {
    this.setState({
      showConfirm: true
    });
  }

  handleOnAction = async (action) => {
    if (action === 'confirm') {
      const { data } = this.props;

      await this.props.cancel(null, data.uuid);
    }

    this.setState({
      showConfirm: false
    });
  }

  render() {
    const { showConfirm } = this.state;

    const { data, busy: cancelling } = this.props;

    if (cancelling) {
      return (
        <LoadingButton type="button"
          variant="transparent"
          loading={ cancelling }
        >
          Cancelando
        </LoadingButton>
      )
    }

    return (
      <>
        { showConfirm &&
          (
            <PopConfirm variant="inline" text="¿Cancelar la factura?"
              onAction={ this.handleOnAction }
            />
          )
        }

        { !showConfirm &&
          (
            <>
              <div className="d-inline-block mr-2">
                <RetencionDownloadActions data={ data } />
              </div>
              { data.status === 'valid' && (
                <div className="d-inline-block">
                  <RetencionMoreActions
                    data={ data }
                    onCancelRequest={ this.handleOnCancelRequest }
                  />
                </div>
              )}
            </>
          )
        }
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return state.app.retenciones.cancel;
}

const mapActionsToProps = (actions) => {
  return actions.app.retenciones.cancel;
}

export default connect(useStore, mapStateToProps, mapActionsToProps)(SingleRetencionActions);